<template>
  <div class='app-setup'>
    <!-- <div class="destaque-1">
      Seja Bem Vindo(a) ao Rotina Fácil  
    </div>
    <br/>
    <br/>
    <p class="destaque-2">
      Por favor, selecione os pacotes que deseja testar:
    </p>

    <RF-Pacotes-Contratados style="text-align: left;"
    :cpntIntencao="cpntIntencao"
    :cpntFecharFormulario="subGerInfCluFechar"
    ></RF-Pacotes-Contratados> -->
  </div>
</template>

<style scoped>
.app-setup {
  width: 905px !important;
  margin: 0px auto !important;
  padding-top: 10px;
  text-align: center;
}
.destaque-1 {
  font-size: 30px;
  font-weight: bold;
  font-weight: 500;
  line-height: 1.1;
  color: #000;
}
.destaque-2 {
  font-size: 16px;
  font-weight: bold;
  font-weight: 500;
  line-height: 1.1;
  color: #000;
}
</style>

<style>
</style>

<script>
  export default {
    // components: {
    //   'RF-Pacotes-Contratados': () => import('@/components/config/pacotes/RF-Pacotes-Contratados.vue'),
    // },
    mounted: function () {
      this.setupLogadoIniciar()
    },
    methods: {
      // subGerInfCluFechar: function () {
      //   // VERIFICA SE DEVE APRESENTAR AS INFORMAÇOES
      //   this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: true }, { chave: 'mascara', value: true }, { chave: 'conteudo', value: true }])

      //   // REDIRECIONA PARA PAGINA INICIAL
      //   this.$router.push({ name: 'pag_inicial' })
      // }
      setupLogadoIniciar: function () {
        // VERIFICA SE TEM PACOTE NO TOKEN
        if (this.$store.state.token.clu_pcc.length === 1 && this.$store.state.token.clu_pcc[0] === 1) {
          // SETA A MASCARA PARA TELA
          this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: true }, { chave: 'conteudo', value: false }])

          // SETA OS PACOTES PADRÕES PARA COMEÇAR
          var pacotes = [ 1, 21, 17 ]
            
          // VERIFICA O PACOTE QUE TEM QUE COLOCAR PARA CADA INTENÇÃO
          switch (this.$store.state.licenca.intencao) {
            case 'oficina':
              pacotes = pacotes.concat([ 4, 6, 8, 15, 20, 23, 25 ])
              break

            case 'petshop':
              pacotes = pacotes.concat([ 4, 6, 28, 15, 20, 23, 25 ])
              break

            case 'contadorplus':
              pacotes = pacotes.concat([ 6, 15, 20, 23, 25, 30, 34, 36 ])
              break

            default:
              pacotes = pacotes.concat([ 4, 6, 20, 23 ])
              break
          }

          // SETA O VETOR QUE SERÁ ENVIADO PARA API
          var formData = { j_pacotes: JSON.stringify(pacotes) }
    
          // FAZ A COMUNICAÇÃO COM A API
          this.$store.state.comunicaAPI('/config/pacote', 'PUT', formData, () => {
            // SETA A PAGINA COM O STATUS DE CARREGANDO
            this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: true }, { chave: 'conteudo', value: false }, { chave: 'setup', value: true }])

            // IMPORA A FUNÇÃO PARA ATUALIZAÇÃO
            const SESSAO_ATUALIZAR_TOKEN = require('@/assets/js/Sessao.js').SESSAO_ATUALIZAR_TOKEN

            // MANDA ATUALIZAR OS PACOTES NO TOKEN
            SESSAO_ATUALIZAR_TOKEN('clu_pcc', () => {
              setTimeout(() => {
                // REMOVE A MASCARA DE CARREGANDO
                this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: true }, { chave: 'conteudo', value: false }, { chave: 'setup', value: false }])
                
                // REDIRECIONA PARA TELA INICIAL
                this.$router.push({ name: 'pag_inicial' })

                // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
                setTimeout(() => { this.$store.commit('SET_ABRIR_CADASTRO_VET', { tipo: 'DETALHES_LU', pagina: 'pacotes' }) }, 100)
                
                // REMOVE A MASCARA DE CARREGANDO
                this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: true }, { chave: 'mascara', value: false }, { chave: 'conteudo', value: true }, { chave: 'setup', value: false }])
              }, 300)
            })
          }, (apiError) => { this.$store.commit('SET_APP_STATUS', apiError) })
        } else {
          // REMOVE A MASCARA DE CARREGANDO
          this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: true }, { chave: 'mascara', value: false }, { chave: 'conteudo', value: true }, { chave: 'setup', value: false }])

          // REDIRECIONA PARA TELA INICIAL
          this.$router.push({ name: 'pag_inicial' })
        }
      }
    },
  }
</script>
